import type { PutDisclosureSettingDTO } from '../service/ai-disclosure.repository.interface';
import type { GoalSettings, BaseRequest } from '../type/ai-disclosure.type';
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { PutDisclosureSetting } from '@/infrastructure/api-functions/interface/put-disclosure-setting.interface';

@injectable()
export class PutDisclosureSettingDTOImpl implements PutDisclosureSettingDTO {
    constructor(
        @inject(PutDisclosureSetting)
        private readonly _putDisclosureSettingApi: PutDisclosureSetting,
    ) {
    }

    async fetch(value: GoalSettings & BaseRequest): Promise<void> {
        const params = {
            invention_subject: value.inventionSubject,
            application_field: value.applicationField,
            tech_means: value.techMeans,
            tech_effect: value.techEffect,
            other: value.other,
            task_id: value.taskId,
            current_step: value.currentStep,
        };

        await this._putDisclosureSettingApi.putDisclosureSetting(params);
    }
}
